import React from 'react';
import { Notification } from '@applyboard/ui-components';
function PassMessage(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React.createElement(Notification, {
    color: "positive",
    "data-testid": "grade-conversion-modal-pass-message"
  }, message ? "The specified score meets the minimum required GPA of this program which is ".concat(message, ".") : 'The specified score meets the minimum required GPA of this program.');
}
function FailMessage(_ref2) {
  var message = _ref2.message;
  return /*#__PURE__*/React.createElement(Notification, {
    color: "warning",
    "data-testid": "grade-conversion-modal-fail-message"
  }, message ? "The specified score does not meet the minimum required GPA of this program which is ".concat(message, ".") : 'The specified score does not meet the minimum required GPA of this program.');
}
function ErrorMessage(_ref3) {
  var message = _ref3.message;
  return /*#__PURE__*/React.createElement(Notification, {
    color: "negative",
    "data-testid": "grade-conversion-modal-error-message"
  }, message);
}
export function StatusMessage(_ref4) {
  var gradeConversionResults = _ref4.gradeConversionResults,
    errorMessage = _ref4.errorMessage;
  if (errorMessage) {
    return /*#__PURE__*/React.createElement(ErrorMessage, {
      message: errorMessage
    });
  }
  var meetsMinimum = gradeConversionResults.meets_minimum;
  if (meetsMinimum === null) {
    return null;
  }
  var minGpaScore = gradeConversionResults.min_required_convert_from_letter_name ? gradeConversionResults.min_required_convert_from_letter_name : gradeConversionResults.min_required_convert_from_score;
  return meetsMinimum ? /*#__PURE__*/React.createElement(PassMessage, {
    message: minGpaScore
  }) : /*#__PURE__*/React.createElement(FailMessage, {
    message: minGpaScore
  });
}